import styled from 'styled-components';
import Check from '../../../assets/v2/DigitalSignage/TickDigital.svg';
import {
  H1,
  H2,
  B1,
  SectionParent,
} from '../../../components/StyledComponents';
import React from 'react';
import RequestDemoForm from '../DigitalSignage/RequestForm';
import CallIcon from '../../../assets/v2/DigitalSignage/phone-call.svg';
// import Lottie from 'react-lottie';
import lottie, { AnimationItem } from 'lottie-web';

const SectionOne = styled(SectionParent)`
  background-repeat: no-repeat;
  background-color: #1b2341;
  /* padding-top: 6rem !important; */
  padding-bottom: 5rem;
  background-size: contain;
  @media (max-width: 1680px) and (min-width: 1440px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 1440px) and (min-width: 768px) {
    padding-bottom: 5rem;
  }
  @media (max-width: 768px) {
    padding-top: 8rem !important;
  }
  @media (max-width: 520px) {
    padding-top: 2rem !important;
    padding-bottom: 5rem !important;
  }
  width: 100%;
  display: grid;
`;

const SectionItemContainer = styled.div`
  grid-template-columns: repeat(2, 1fr);
  padding-top: 5rem;
  padding-left: 5rem;
  display: grid;
  @media (max-width: 768px) {
    padding-left: 0rem;
    padding-top: 2rem;
  }
`;

const GridLeft = styled.div`
  grid-column: span 1;
  /* padding-left: 7rem; */
  max-width: 50%;
  position: relative;
  @media (max-width: 1100px) {
    padding-left: 0;
  }
  @media (max-width: 768px) {
    grid-column: span 2;
    padding-left: 0;
    max-width: 15rem;
    justify-self: center;
  }
`;

const HeroSubTitle = styled.div`
  padding-top: 2rem;
  margin-left: 3rem;
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.64;
  letter-spacing: normal;
  color: #ffffff;
  @media (max-width: 768px) {
    text-align: center;
    margin-left: 0rem;
  }

  @media (max-width: 520px) {
    text-align: center;
    padding-top: 0.5rem;
    margin-bottom: -1rem;
    margin-left: 0;
  }
`;
const FormComponentLeft = styled.div`
  padding: 0rem 6rem;
  display: grid;
  grid-column: span 1;
  align-content: center;
  grid-column: span 1;
  justify-items: center;
  width: 100%;

  @media (max-width: 1440px) {
    padding: 0rem 3rem;
  }
  @media (max-width: 768px) {
    padding: 0rem 3rem;
    border-radius: 8px 8px 0px 0px;
    grid-column: span 2;
  }
  @media (max-width: 520px) {
    padding: 0rem;
  }
  @media (max-width: 400px) {
    padding: 0rem 2rem;
  }
`;

const FormComponentLeftList = styled.ul`
  /* margin-left: 40px; */
  padding-left: 0.5em;
  list-style: none;
  @media (max-width: 768px) {
    display: none;
  }
`;

const FormComponentLeftListItem = styled.li`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 18px;
  @media (max-width: 1024px) {
    font-size: 16px;
  }
  @media (max-width: 768px) {
    font-size: 14px;
  }
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #298de5;
  background: url(${Check}) no-repeat;
  padding: 0.3em 0px 0.1em 30px;
  background-size: 18px;
  background-position-y: center;
  @media (max-width: 320px) {
    font-size: 12px;
  }
`;
const SectionOneTitle = styled(H1)`
  color: #ffffff;
  font-weight: bold;
  margin-bottom: 0;
  @media (min-width: 1440px) {
    font-size: 28px !important;
  }
  @media (max-width: 768px) {
    text-align: center;
  }
  @media (max-width: 520px) {
    text-align: center;
  }
`;
const FromManufacturingT = styled(H2)`
  /* font-size: 18px; */
  line-height: 31px;
  color: #ffffff;
  text-align: center;
  font-weight: bold;
  /* @media (max-width: 1700px) {
    font-size: 18px;
  }
  @media (max-width: 1440px) {
    font-size: 18px;
  } */
  @media (max-width: 1024px) {
    font-size: 18px;
  }
  @media (max-width: 768px) {
    font-size: 16px;
    width: 80%;
    margin-left: 10%;
    text-align: center;
  }
  margin-bottom: 0rem;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 520px) {
    /* margin-bottom: -50%; */
    width: 95%;
    padding: 0 3rem;
    line-height: 1.5;
    margin-left: 0;
  }
  @media (max-width: 375px) {
    padding: 0 1rem;
  }
`;
const HeroImgContainerLeft = styled.img`
  width: 50%;
  height: fit-content;
  justify-self: center;
`;
const HeroImgContainer = styled.div`
  display: grid;
  padding: 2rem 0rem;
`;
export default class HealthSectionSeven extends React.Component<any, any> {
  render() {
    return (
      <div>
        <SectionOne id="section-one-kiosk">
          <SectionItemContainer>
            <FormComponentLeft>
              <div>
                <SectionOneTitle
                  style={{
                    textAlign: 'center',
                  }}
                >
                  Inquire about our complete range of healthcare solutions for
                  organizations of all sizes.
                </SectionOneTitle>
                <HeroImgContainer>
                  <HeroImgContainerLeft alt="Esper Developer" src={CallIcon} />
                </HeroImgContainer>
                <FromManufacturingT>
                  Esper is committed to changing Android telehealth security and
                  product design, one device at a time.
                </FromManufacturingT>
              </div>
            </FormComponentLeft>
            <GridLeft>
              <RequestDemoForm
                formId="healthcare_section"
                messages={this.props.messages}
              />
            </GridLeft>
          </SectionItemContainer>
        </SectionOne>
      </div>
    );
  }
}
